var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "brl-btn",
      class: { loading: _vm.loading },
      attrs: { disabled: _vm.disabled },
      on: { click: _vm.handleClick }
    },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "loader-wrapper" },
            [
              _c("LoadingAnimation", { attrs: { size: "small", type: "dots" } })
            ],
            1
          )
        : _c("span", [_vm._v(_vm._s(_vm.text))])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }